import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useAuthStore } from "./auth.store";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isLoading) return;

    setError("");
    setIsLoading(true);

    try {
      await login(email, password);
      navigate("/");
    } catch (error) {
      console.error("Login failed:", error);
      setError("Invalid email or password");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-[#0D1016]">
      <div className="max-w-md w-full space-y-8 bg-[#1C2130] p-8 rounded-[30px] border border-[#2A3441]">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto rounded-full bg-[#2A3441] flex items-center justify-center">
            <MessageSquare className="h-8 w-8 text-[#00C0FF]" />
          </div>
          <h2 className="mt-6 text-3xl font-bold text-white font-['onest']">
            DocuTalk Admin
          </h2>
          <p className="mt-2 text-[#64748B] font-['onest']">
            Sign in to your account
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="text-center p-3 rounded-xl bg-[#EF4444]/10 text-[#EF4444] border border-[#EF4444]/20">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="appearance-none rounded-xl relative block w-full px-4 py-3 bg-[#0D1016] border border-[#2A3441] text-white placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#00C0FF] focus:border-[#00C0FF] transition-colors"
                placeholder="Email address"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="appearance-none rounded-xl relative block w-full px-4 py-3 bg-[#0D1016] border border-[#2A3441] text-white placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#00C0FF] focus:border-[#00C0FF] transition-colors"
                placeholder="Password"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-xl bg-[#00C0FF] text-white hover:bg-[#00C0FF]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#00C0FF] transition-colors disabled:opacity-50"
          >
            {isLoading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
